import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router  } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import { store } from '@redux/store';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SnackbarProvider 
      maxSnack={3}
      anchorOrigin = {
        {
          vertical:"bottom" ,
          horizontal:"center"
        }
      }
    >
      <Provider store={store}>
        <Router>
          <App />
        </Router>
      </Provider>
    </SnackbarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
